import { useFormikContext } from "formik";
import get from "lodash-es/get";
import React from "react";
import PropTypes from "prop-types";
import TextField from "ui/TextField";

export const FormTextField = (props) => {
  const { name, label, helperText, ...otherProps } = props;
  const formik = useFormikContext();

  const value = get(formik.values, name, "");
  const touched = get(formik.touched, name, false);
  const error = get(formik.errors, name, "");
  const hasError = Boolean(error);

  return (
    <TextField
      id={`text-field-${name}`}
      fullWidth
      name={name}
      value={value}
      label={label}
      onChange={formik.handleChange}
      error={touched && hasError}
      sx={{ wordBreak: "normal" }}
      helperText={(touched && error) || helperText}
      {...otherProps}
    />
  );
};
FormTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
};
